import { Button } from 'components/button';
import { Input } from '../../../components/react-hook-form-6/input';
import { useForm } from 'react-hook-form-6';

export const CreateFilterItem = ({
  onCreateFilterItem,
  onClose,
  loading,
}: {
  onCreateFilterItem: ({ title }: { title: string }) => void;
  onClose: () => void;
  loading: boolean;
}) => {
  const { register, handleSubmit, errors } = useForm<{ title: string }>();

  const onSubmit = handleSubmit(({ title }) => {
    onCreateFilterItem({
      title,
    });
  });

  return (
    <div>
      <h2 className="heading-md mb-5">Create Filter Item</h2>
      <form onSubmit={onSubmit}>
        <div className="flex flex-col space-y-8">
          <Input
            name="title"
            label="Title"
            ref={register({ required: true })}
            errorMessage={errors.title?.message}
          />
          <div className="flex flex-row space-x-4">
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button color="success" type="submit" disabled={loading}>
              Add
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};
